<template>
    <TotemTreeSelect
        :options="categoriesOptions"
        :placeholder="$t('CourseListFilter.categories')"
        @input="selectCategoryOption"
        ref="select"
        class="filter-select"
        :selectedOptions="currentFilter"
        v-on:deselectAll="onDeselectAll"
        v-on:setFilterValues="setFilterValues"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'search-tree-select-filter',
        props: {
            filterKey: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                categoriesIntoTreeModel: 'Search/getFilteredCategories',
                filtersWithFacets: 'Search/filtersWithFacets',
                filtersWithKey: 'Search/filterWithKey',
            }),
            categoriesOptions () {
                const categoriesFromFacets = this.filtersWithFacets[this.filterKey].map(filterItem => ({
                    label: this.labels ? `${this.labels[filterItem.label]} (${filterItem.count})` : `${filterItem.label} (${filterItem.count})`,
                    labelWithoutCount: filterItem.label,
                    value: filterItem.value,
                    selected: filterItem.selected,
                    note: this.notes ? this.notes[filterItem.label] : null
                }))
                return this.categoriesIntoTreeModel(categoriesFromFacets)
            },
            currentFilter () {
                return this.filtersWithKey(this.filterKey)
            }
        },
        watch: {
            currentFilter (val) {
                if ((Array.isArray(val) && val.length === 0) || !val) {
                    return this.clearWithoutEmit()
                }
            }
        },
        methods: {
            selectCategoryOption (payload) {
                if (payload === null) {
                    this.$store.dispatch('Search/clearFilter', { key: this.filterKey })
                }
            },
            clear () {
                if (this.$refs.select) {
                    this.$refs.select.clear()
                }
            },
            clearWithoutEmit () {
                if (this.$refs.select) {
                    this.$refs.select.clearWithoutEmit()
                }
            },
            setFilterValues (payload) {
                this.$store.dispatch('Search/setFilterValues', { filters: payload, key: this.filterKey })
            },
            onDeselectAll () {
                this.$store.dispatch('Search/clearFilter', { key: this.filterKey })
            }
        },
        created () {
            this.$store.dispatch('Search/loadCategories')
        }
    }
</script>
